import type { Payer } from "./utils";

export enum Fields {
  FitrahDependant,
  FitrahRate,
  PaidAmount,
  Name,
  Address,
  Address2,
  Address3,
  City,
  DaerahSelect,
  DaerahText,
  Postcode,
  State,
  Email,
  Phone,
  IC,
  FitrahRateCustom,
}

export interface IStates {
  [key: string]: IState;
}

export interface IState {
  fields: Fields[];
  optional_fields?: Fields[];
  fitrah_rates: number[];
  kariah?: boolean;
  amil?: boolean;
  amil_optional?: boolean;
  daerah_list?: { [key: string]: string[] };
  logo: string;
  akad?: boolean;
  simple_akad?: boolean;
  doa?: boolean;
  zakat_code: string; // TODO this is a temp
  state: string;
  extras_func: (payer: Payer) => string;
}

export const extras_to_json = (payer: Payer): string => {
  return encodeURIComponent(JSON.stringify(payer));
};

export const extras_maidam = (payer: Payer): string => {
  console.log(payer);
  return (
    encodeURIComponent(payer.ic_no || "") +
    "~" +
    encodeURIComponent(payer.zakat_code) +
    "~" +
    encodeURIComponent(payer.name || "") +
    "~" +
    encodeURIComponent(payer.phone || "") +
    "~" +
    encodeURIComponent(payer.address?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.address_2?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.address_3?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.postcode || "") +
    "~" +
    encodeURIComponent(payer.daerah?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.state?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.dependant) +
    "~" +
    encodeURIComponent(payer.rate)
  );
};

export const extras_maij = (payer: Payer): string => {
  console.log("extras_maij", payer);
  return (
    encodeURIComponent(payer.ic_no || "") +
    "~" +
    encodeURIComponent(payer.zakat_code || "") +
    "~" +
    encodeURIComponent(payer.name?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.phone || "") +
    "~" +
    encodeURIComponent(payer.address?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.address_2?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.address_3?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.postcode || "") +
    "~" +
    encodeURIComponent(payer.daerah?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.state?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.dependant) +
    "~" +
    encodeURIComponent(payer.rate)
  );
};

export const extras_others = (payer: Payer): string => {
  return (
    encodeURIComponent(payer.ic_no || "") +
    "~" +
    encodeURIComponent(payer.zakat_code || "") +
    "~" +
    encodeURIComponent(payer.name?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.phone || "") +
    "~" +
    encodeURIComponent(payer.address?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.address_2?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.address_3?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.postcode || "") +
    "~" +
    encodeURIComponent(payer.daerah?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.state?.toUpperCase() || "") +
    "~" +
    encodeURIComponent(payer.dependant) +
    "~" +
    encodeURIComponent(payer.rate)
  );
};

export const stateList = [
  "JOHOR",
  "KEDAH",
  "KELANTAN",
  "MELAKA",
  "NEGERI SEMBILAN",
  "PAHANG",
  "PERAK",
  "PERLIS",
  "PULAU PINANG",
  "SABAH",
  "SARAWAK",
  "SELANGOR",
  "TERENGGANU",
  "WP KUALA LUMPUR",
  "WP LABUAN",
  "WP PUTRAJAYA",
];

export const stateConfig: IStates = {
  MAIWP: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [5, 7, 14],
    amil: true,
    amil_optional: true,
    logo: "MAIWP.png",
    akad: true,
    simple_akad: true,
    doa: true,
    state: "WP KUALA LUMPUR",
    zakat_code: "zakat_fitrah", //"12",
    extras_func: extras_to_json,
  },
  MAIWPLB: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [5, 7, 14],
    amil: true,
    amil_optional: true,
    logo: "MAIWP.png",
    akad: true,
    simple_akad: true,
    doa: true,
    state: "WP LABUAN",
    zakat_code: "zakat_fitrah", //"12",
    extras_func: extras_to_json,
  },
  LZS: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7, 14, 21],
    logo: "LZS.jpg",
    state: "SELANGOR",
    zakat_code: "zakat_fitrah", //"12",
    akad: true,
    doa: true,
    extras_func: extras_others,
  },
  PHGFITRAH: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7, 16],
    logo: "PHGFITRAH.png",
    state: "PAHANG",
    zakat_code: "zakat_fitrah", //"12",
    akad: true,
    doa: true,
    extras_func: extras_others,
  },
  MDMFITRAH: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.DaerahSelect,
      Fields.Postcode,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
      Fields.FitrahRateCustom,
    ],
    fitrah_rates: [7],
    daerah_list: {
      TERENGGANU: [
        "01-Besut",
        "02-Dungun",
        "03-Kemaman",
        "04-Kuala Terengganu",
        "05-Marang",
        "06-Hulu Teregganu",
        "07-Setiu",
        "08-Kuala Nerus",
        "99-Lain-lain",
      ],
      default: ["99-Lain-lain"],
    },
    logo: "MAIDAM.png",
    state: "TERENGGANU",
    zakat_code: "zakat_fitrah", //"79102",
    akad: true,
    doa: true,
    // simple_akad: true,
    extras_func: extras_maidam,
  },
  PRKFITRAH: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7, 14, 21],
    logo: "ZKPRK.png",
    akad: true,
    doa: true,
    state: "PERAK",
    zakat_code: "zakat_fitrah", //"12",
    extras_func: extras_others,
  },
  ZKPNG: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7, 12, 16],
    amil: true,
    amil_optional: true,
    kariah: true,
    akad: true,
    doa: true,
    logo: "ZKPNG.jpg",
    state: "PULAU PINANG",
    zakat_code: "zakat_fitrah", //"12",
    extras_func: extras_to_json,
  },
  SBHFITRAH: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7],
    logo: "SBHFITRAH.png",
    akad: true,
    doa: true,
    state: "SABAH",
    zakat_code: "zakat_fitrah", //"12",
    extras_func: extras_others,
  },
  JHRFITRAH: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7, 10],
    logo: "MAIJ.png",
    akad: true,
    doa: true,
    state: "JOHOR",
    zakat_code: "zakat_fitrah", //"12",
    extras_func: extras_maij,
  },
  MAIJ: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7, 10],
    logo: "MAIJ.png",
    akad: true,
    doa: true,
    state: "JOHOR",
    zakat_code: "zakat_fitrah", //"12",
    extras_func: extras_maij,
  },
  KDHFITRAH: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7],
    logo: "LZNK.jpg",
    akad: true,
    doa: true,
    state: "KEDAH",
    zakat_code: "zakat_fitrah", //"12",
    extras_func: extras_others,
  },
  TBSFITRAH: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7],
    logo: "TBS.png",
    akad: true,
    doa: true,
    state: "SARAWAK",
    zakat_code: "zakat_fitrah", //"12",
    extras_func: extras_others,
  },
  MAKFITRAH: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7, 14, 21],
    logo: "MAIK.png",
    akad: true,
    doa: true,
    state: "KELANTAN",
    zakat_code: "zakat_fitrah", //"12",
    extras_func: extras_others,
  },
  NSNFITRAH: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7],
    logo: "MAINS.jpg",
    akad: true,
    doa: true,
    state: "NEGERI SEMBILAN",
    zakat_code: "zakat_fitrah", // "12",
    extras_func: extras_others,
  },
  PLSFITRAH: {
    fields: [
      Fields.Name,
      Fields.IC,
      Fields.Address,
      Fields.Address2,
      Fields.Address3,
      Fields.Postcode,
      Fields.DaerahText,
      Fields.State,
      Fields.Phone,
      Fields.FitrahDependant,
      Fields.FitrahRate,
      Fields.PaidAmount,
      Fields.Email,
    ],
    fitrah_rates: [7],
    logo: "MAIPS.png",
    akad: true,
    doa: true,
    state: "PERLIS",
    zakat_code: "zakat_fitrah", //"12",
    extras_func: extras_others,
  },
};

export class States {
  private states: IStates = stateConfig;

  public validateState(agency: string): boolean {
    if (this.states[agency]) {
      return true;
    }
    return false;
  }

  public getState(agency: string): State | never {
    const state = this.states[agency];
    if (!state) {
      throw new Error("unknown state");
    }
    return new State(state);
  }

  public getStateList(): string[] {
    return stateList;
  }
}

export const states = new States();

export class State implements IState {
  fields: Fields[];
  optional_fields?: Fields[];
  fitrah_rates: number[];
  amil?: boolean;
  amil_optional?: boolean;
  daerah_list?: { [key: string]: string[] };
  logo: string;
  akad?: boolean;
  simple_akad?: boolean;
  kariah?: boolean;
  doa?: boolean;
  zakat_code: string;
  state: string;
  extras_func: (payer: Payer) => string;

  constructor(state: IState) {
    this.fields = state.fields;
    this.optional_fields = state.optional_fields;
    this.fitrah_rates = state.fitrah_rates;
    this.amil = state.amil;
    this.amil_optional = state.amil_optional;
    this.daerah_list = state.daerah_list;
    this.kariah = state.kariah;
    this.logo = state.logo;
    this.akad = state.akad;
    this.simple_akad = state.simple_akad;
    this.doa = state.doa;
    this.zakat_code = state.zakat_code;
    this.state = state.state;
    this.extras_func = state.extras_func;
  }

  public hasField(field: Fields): boolean {
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i] === field) {
        return true;
      }
    }

    return false;
  }

  public isFieldOptional(field: Fields): boolean {
    if (!this.optional_fields) {
      return false;
    }

    for (let i = 0; i < this.optional_fields.length; i++) {
      if (this.optional_fields[i] === field) {
        return true;
      }
    }

    return false;
  }

  public isAmilOptional(): boolean {
    console.log(this.amil_optional);
    if (this.amil_optional) {
      return true;
    }

    return false;
  }

  public hasAmil(): boolean {
    if (this.amil) {
      return true;
    }

    return false;
  }

  public hasKariah(): boolean {
    if (this.kariah) {
      return true;
    }

    return false;
  }

  public hasDaerah(): boolean {
    if (this.daerah_list) {
      return true;
    }

    return false;
  }
}
